import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

interface LocaleContextValue {
  locale: "en" | "ar";
  direction: "ltr" | "rtl";
  setLocale: (locale: "en" | "ar") => void;
}

const LocaleContext = createContext<LocaleContextValue | null>(null);

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<"en" | "ar">("en");
  const setLocale = (next: "en" | "ar") => {
    setLocaleState(next);
    document.documentElement.lang = next;
    document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
  };
  const value = useMemo(() => ({ locale, direction: locale === "ar" ? "rtl" as const : "ltr" as const, setLocale }), [locale]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);
  if (context === null) throw new Error("useLocale must be used within LocaleProvider.");
  return context;
}
